module.exports = __webpack_public_path__ + "static/img/kb-card-img-02-04@w.d00a9c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/kb-card/kb-card-img-02-04@w.jpg
// module id = ZPsm
// module chunks = 0